
export const adultChannels = [
  "Gewaagd",
  "Ongewenst",
  "SM Dungeon",
  "Pikant",
  "Bi-Box",
  "Lesbox",
  "Gaylife",
  "Admin Hulp"
];